import angular from 'angular'
import UiFormComponents from './components'
import UiFormDirectives from './directives'

export default angular.module('rb.ui-form', [ UiFormComponents, UiFormDirectives ])
